class UchPdpHolsterSelector extends YWM {
 constructor(options) {
 super(options)

 this.selectedMake = this.getCookie("uch_make")
 this.selectedModel = this.getCookie("uch_model")
 if (this.getCookie("uch_model")?.trim()=="") {
 this.selectedModel = null;
 }
 if (this.getCookie("uch_make")?.trim()=="") {
 this.selectedMake = null;
 }
 this.confirmedCompatible=false;
 this.selectedSize = this.getCookie("uch_size");
 this.hasSizeCookie = this.selectedSize && this.getCookie("uch_size");
 if (this.hasSizeCookie) {
 this.setPropertiesForSize(this.selectedSize)
 }
 
 this.compatibleSizes = [];
 this.compatibleHolsters = [];
 this.selectedFirearm = null;
 this.currentHolster = null;
 this.currentSize = null;
 

 this.allowSizeOnlySelection = true;
 
 this.formSizeField = "Holster Size";
 this.formMakeField = "Make";
 this.formModelField = "Model";

 

 
 this.currentHolster = window.firearmsDB.holsterById(this.config.product);
 this.selectedSize = this.currentHolster.size;
 if (this.currentHolster==null) {
 
 return;
 }
 this.compatibleSizes = window.firearmsDB.siblingsOf(this.currentHolster);
 
 if (this.hasSizeCookie && !this.compatibleSizes.map(size=>size.size).includes(this.getCookie("uch_size"))) {
 this.setCookieForMinutes("uch_size",this.currentHolster.size)
 }
 this.setFirearm();
 if (this.holstersCompatibilityCheck()) {
 this.render();
 }
 if (this.selectedSize && this.hasSizeCookie) {
 this.setPropertiesForSize(this.selectedSize);
 } else {
 //this.unsetHiddenFormValue(this.getProductForm(),this.formSizeField)
 }
 if (!this.hasSizeCookie && !this.getCookie("uch_model") && !this.getCookie("uch_size")) {
 this.DOMTarget().querySelector(".weapon-selector-wrapper").classList.toggle("show-selections");
 }

 document.addEventListener(
 "ywm:autoselect:success",
 event=>{
 
 
 this.setFirearm(event.detail);

 if (event.detail.holsters?.includes(this.currentHolster.id)) {
 this.confirmedCompatible=true;
 } else {
 this.confirmedCompatible=false;
 }

 if (this.holstersCompatibilityCheck()) {
 this.DOMTarget().querySelector("#autocomplete").value=event.detail.fullName; 
 let noneselected = document.querySelector(".no-model-set")
 noneselected?.parentNode.removeChild(noneselected)
 this.render();
 }
 
 }
 )
 document.dispatchEvent(
 new CustomEvent(
 "ywm:selector:ready",
 {
 bubbles:true,
 detail:{}
 }
 )
 )
 
 }
 setUrl() {
 let searchParams = new URLSearchParams(location.search);
 let newUrl = `${location.pathname}#for/${this.selectedMake}/${this.selectedModel}?${searchParams.toString()}`;
 console.error(newUrl);
 history.replaceState(null,null,newUrl);
 }

 setFirearm(firearm=null) {
 if (firearm==null) {
 
 if (this.selectedMake!=null && this.selectedModel!=null) {
 this.selectedFirearm = window.firearmsDB.firearmByMakeModel(this.selectedMake,this.selectedModel);
 } 
 } else {
 this.selectedMake = firearm.manufacturer;
 this.selectedModel = firearm.name;
 this.setCookieForMinutes("uch_make",firearm.manufacturer,15);
 this.setCookieForMinutes("uch_model",firearm.name,15);
 this.selectedFirearm = firearm;
 let productForm = this.getProductForm();
 this.setHiddenFieldValue(productForm,this.formMakeField,this.selectedFirearm.manufacturer);
 this.setHiddenFieldValue(productForm,this.formModelField,this.selectedFirearm.name);
 if (this.selectedFirearm.size && this.selectedFirearm.size!="0") {
 this.setHiddenFieldValue(productForm,this.formSizeField,this.selectedFirearm.size);
 }
 }
 
 
 if (this.selectedFirearm!=null) {
 this.compatibleHolsters = window.firearmsDB.holstersByModel(this.selectedFirearm)
 this.setCookieForMinutes("uch_make",this.selectedMake,15)
 this.setCookieForMinutes("uch_model",this.selectedModel,15)
 //this.deleteCookie("uch_size");
 } 
 }
 DOMTarget() {
 return document.querySelector(this.config.selector);
 }
 renderSelectorHeader() {
 if (this.selectedFirearm) {
 return `<span id="current-make">${this.selectedMake}</span>&nbsp; <span id="current-model">${this.selectedModel}</span>`
 } else if (this.selectedSize && this.hasSizeCookie) {
 return `<span id="current-make">Size</span>&nbsp; <span id="current-model">${this.selectedSize}</span>`
 } else {
 return '';
 }
 }
 autocompleteValue() {
 if (this.selectedFirearm) {
 return this.selectedFirearm.fullName
 } else if (this.selectedSize && this.hasSizeCookie) {
 return `Size ${this.selectedSize}`
 } else {
 return ''
 }
 }
 renderCompatibleHolsters() { 
 
 if (this.selectedFirearm) {
 if (this.compatibleHolsters?.length>0) {
 return `
 <div class="select-wrap select-size">
 <label class="select-label" for="selectHolster">Compatible Holsters:</label>
 <select name="selectHolster" id="selectHolster" data-placeholder="Choose your product" area-label="Select your holster">
 <option value="">Select product...</option>
 ${this.compatibleHolsters.map(
 holster=>`
 <option value="${holster.id}" data-url="/products/${holster.handle}?variant=${holster.variants[0]?.id}" ${holster.id==this.config.product?'selected':''}>
 ${window.firearmsDB.shortTitleFor(holster)}
 </option>
 `).join("")}
 </select>
 </div>
 </div>
 `
 } else {
 return `<div class="unavailable-text" aria-label="No options are available">
 No options are available for the <span class="make-model-text">${this.selectedFirearm.fullName}</span>
 </div>
 `
 }
 } else {
 return `<div class="select-model-text">Select your firearm's make and model</div>`
 }
 return ''
 }
 
 renderSiblingSizes() {
 
 if (this.compatibleSizes.length>1) {
 return `
 <div class="select-wrap" id="alt-size">
 <div style="flex:1 1 100%;color:#aaa;">
 <label for="know-your-size-toggle" id="size-toggle" style="cursor: pointer">
 <small>Already know your size?</small>
 </label>
 <input type="checkbox" id="know-your-size-toggle" name="show-sizes" style="display: none;" aria-labelledby="size-toggle">
 </div>
 <select name="selectSizeList" id="selectSize" data-placeholder="Choose your weapons size" aria-label="Select Holster Size">
 <option value="">Set holster size...</option>
 ${this.compatibleSizes.map(option=>`
 <option value="${option.id}" data-url="${option.url}" data-size="${option.size}"}>
 ${option.label}
 </option>
 `).join("")}
 </select>
 </div>
 `;
 }
 return '';
 }
 
 render() {
 this.DOMTarget().innerHTML = `
 <div class="compatibility-indicator">${this.confirmedCompatible?`✓ VERIFIED fit for ${event.detail.fullName}`:''}</div>
 <div class="weapon-selector-wrapper" data-for="${this.config.product}">
 <div class="weapon-selector ywm-dl">
 <div id="choose-weapon"><a href="#" id="ywm-dl-change">Change</a></div> 
 <div id="current-weapon" style="display: flex;">${this.renderSelectorHeader()}</div>
 </div>
 <div id="weapon-${this.config.product}" class="firearms-search">
 
 <div class="section_filter-metaobject page-width" id="${this.config.pageId}">
 
 <div class="select-wrap">
 <label for="autocomplete" class="select-label">Make/Model:</label>
 <input 
 id="autocomplete"
 data-for="${this.config.product}"
 type="text"
 placeholder="Search..." 
 autocomplete="off" 
 aria-placeholder="Search for your firearm's make and model"
 aria-controls="autoComplete_list_1" 
 aria-autocomplete="both"
 value="${this.autocompleteValue().replace('"','¨')}"
 >
 <ul id="autoComplete_list_1" role="listbox" hidden=""></ul>
 </div>
 <div class="select-firearm-size">
 
 ${this.renderCompatibleHolsters()}
 ${this.renderSiblingSizes()}
 </div>
 </div>
 </div>
 `;
 this.setupEvents()
 }
 wrapper() {
 return this.DOMTarget().querySelector(".weapon-selector-wrapper")
 }
 notifications() {
 let el = document.querySelector(".uch-compat-notice");
 if (!el) {
 el = document.createElement("div");
 el.className = "uch-compat-notice";
 el.setAttribute("role", "alert");
 this.atc().insertAdjacentElement("afterend", el);
 }
 return el;
}
 atc() {
 return this.getProductForm().querySelector(`.add-to-cart`)
 }
 compatibilityError() {
 return;
 this.wrapper().classList.add("no-selection")
 this.wrapper().classList.remove("show-selections")
 
 window.setTimeout(
 ()=>{
 this.notifications().textContent = `The ${this.currentHolster.title} is not compatible with a ${this.selectedFirearm.fullName}`
 this.atc().disabled=true
 }
 ) 
 let redirectUrl = this.getLineMatchingURL()
 if (redirectUrl) {
 location.href = redirectUrl
 }
 }
 validate() {
 this.notifications().innerHTML = "";
 this.wrapper().classList.add("show-selections")
 if (this.selectedSize && this.allowSizeOnlySelection && this.hasSizeCookie) {
 let isCurrentlyCompatible = this.compatibleHolsters.map(holster=>holster.id).includes(this.config.product);
 if (isCurrentlyCompatible) {
 this.atc().disabled = false;
 this.wrapper().classList.remove("show-selections")
 this.wrapper().classList.add("no-selections")
 } else {
 if (this.selectedFirearm) {
 this.compatibilityError()
 } else {
 this.atc().disabled = false;
 this.wrapper().classList.remove("show-selections")
 this.wrapper().classList.add("no-selections")
 }
 
 }
 


 
 return;
 }
 if (this.compatibleHolsters.length<1) {
 
 this.wrapper().classList.add("no-selection")
 this.wrapper().classList.remove("show-selections")
 if (this.selectedFirearm) {
 this.notifications().textContent = `The ${this.selectedFirearm.fullName} has no compatible holsters`
 } else {
 this.notifications().textContent = "Select your firearm's make and model"
 }
 this.atc().disabled = true;
 } else if (!this.compatibleHolsters.map(holster=>holster.id).includes(this.config.product)) {
 this.compatibilityError()
 /*
 this.wrapper().classList.add("no-selection")
 this.wrapper().classList.remove("show-selections")
 
 
 this.notifications().textContent = `The ${this.currentHolster.title} is not compatible with a ${this.selectedFirearm.fullName}`
 this.atc().disabled=true
 this.wrapper().classList.add("no-selection")
 this.wrapper().classList.remove("show-selections")
 */
 
 
 // this.notifications().textContent = `The ${this.currentHolster.title} is not compatible with a ${this.selectedFirearm.fullName}`
 let fixUrl = this.getLineMatchingURL();
 if (!fixUrl && this.compatibleHolsters.length) {
 const h = this.compatibleHolsters[0];
 fixUrl = `/products/${h.handle}?variant=${h.variants[0].id}`;
 }
 const msg = `The ${this.currentHolster.title} is not compatible with a ${this.selectedFirearm.fullName}.`;
 this.notifications().innerHTML = fixUrl
 ? `${msg} <a href="${fixUrl}${location.hash}">View the size that fits</a>`
 : msg;
 this.atc().disabled=true;

 if (!this.selectedSize) {
 this.atc().disabled = true;
 } else {
 //this.atc().disabled = false;
 }
 
 } else {
 this.atc().disabled=false;
 }
 this.wrapper().classList.remove("show-selections")
 /* update holster */
 let updatedHolster = this.compatibleHolsters.find(
 holster=>holster.id==this.currentHolster?.id
 )
 if (updatedHolster && updatedHolster!=this.currentHolster.variants[0].id!=updatedHolster.variants[0].id) {
 this.currentHolster = updatedHolster
 if (this.currentHolster.holsterSelectionLabel) {
 let slug = this.currentHolster.optionNameSlug;
 let selectionWrapper = document
 .querySelector(`.variant-wrapper--dropdown`).querySelector(`[data-handle="${this.currentHolster.optionNameSlug}"]`);
 if (selectionWrapper) {
 
 
 
 let select = selectionWrapper.querySelector("select");
 selectionWrapper.style.display = "none";
 
 document.querySelector(`label[for="${select.id}"]`).style.display="none";
 select.querySelectorAll("select option").forEach(
 option=>{
 
 if (option.value.trim()==this.currentHolster.holsterSelectionLabel.trim()) {
 
 
 option.selected = true;
 selectionWrapper.querySelector("select").dispatchEvent(new Event("change"));
 }
 }
 )
 } else {
 console.error(`unable to find selection 'variant-wrapper--dropdown:has([data-handle="${this.currentHolster.optionNameSlug}"])'`)
 }
 }
 }
 
 let productForm = this.getProductForm();
 if (productForm) {
 
 let formData = new FormData(productForm);
 let variantId = formData.get("id");
 history.replaceState(null,null,`?variantId=${variantId}`);
 if (this.selectedFirearm) {
 this.setHiddenFieldValue(productForm,this.formMakeField,this.selectedFirearm.manufacturer);
 this.setHiddenFieldValue(productForm,this.formModelField,this.selectedFirearm.name);
 if (this.selectedFirearm.size && this.selectedFirearm.size!="0") {
 this.setHiddenFieldValue(productForm,this.formSizeField,this.selectedFirearm.size);
 }
 }
 }
 }
 getProductForm() {
 return document
 .querySelector(`[data-section-type="product"][data-product-id="${this.config.product}"] form`);
 }
 setPropertiesForSize(size) {
 let productForm = this.getProductForm()
 this.setHiddenFieldValue(productForm,this.formSizeField,this.selectedSize);

 this.setHiddenFieldValue(productForm,this.formMakeField,"Size")
 this.unsetHiddenFormValue(productForm,this.formModelField)
 }
 getSortedMatchingItems(firearmsList,sortBy="default") {
 /* get featured firearms */
 let featuredItems = firearmsList.filter(firearm=>firearm.featured);
 switch(sortBy) {
 case "alpha":
 featuredItems = featuredItems.sort(
 (a,b)=>a.alphaCode-b.alphaCode
 )
 break;
 }
 let standardItems = firearmsList.filter(firearm=>!firearm.featured);
 
 return featuredItems.concat(standardItems)
 }
 mapAutocompleteResults(list,start=0) {
 return list.map((sortedResult,index)=>`
 <li id="autoComplete_result_${index+start}" role="option">
 ${sortedResult.fullName}
 </li>
 `).join("")
 }
 getMatchingFirearms(query,list) {
 
 if (list.fullName.toLowerCase().includes(query.toLowerCase())) {
 
 return list;
 } else {
 return null;
 }
 }

 setupEvents() {
 this.DOMTarget().querySelector("#selectSize")?.addEventListener("change",event=>{
 let option = event.target.options[event.target.selectedIndex];
 let optionSize = option.dataset.size;
 if (option.value!="") {
 if (this.allowSizeOnlySelection){
 //this.deleteCookie("uch_make")
 //this.deleteCookie("uch_model")
 }
 if (option.value.toString()!=this.currentHolster.id.toString()) {
 this.setPropertiesForSize(optionSize,15);
 this.setCookieForMinutes("uch_size",optionSize);
 this.setCookieForMinutes("uch_make","Size");
 this.setCookieForMinutes("uch_model",optionSize);
 
 location.href=`${option.dataset.url}`;
 } else {
 
 this.setCookieForMinutes("uch_size",optionSize,15)
 this.setPropertiesForSize(optionSize,15)
 this.hasSizeCookie=true;
 this.atc().disabled = false;
 this.render()
 }
 
 }
 })
 this.DOMTarget().querySelector("#selectHolster")?.addEventListener("change",event=>{
 let option = event.target.options[event.target.selectedIndex];
 if (option.value!="") {
 
 location.href=`${option.dataset.url}`;
 }
 })
 this.DOMTarget().querySelector("#ywm-dl-change")?.addEventListener(
 "click",
 event=>{
 event.stopPropagation();
 event.preventDefault();
 this.DOMTarget().querySelector(".weapon-selector-wrapper").classList.toggle("show-selections");
 }
 )
 let itemsToShow = this.config.limitResults?this.config.visibleResultsCount:99999999;
 
 const autoCompleteJS = new autoComplete({
 selector: `#autocomplete[data-for="${this.config.product}"]`,
 data: {
 src: window.firearmsDB.flat(),
 },
 cache: false, // Enable caching for data
 searchEngine:this.getMatchingFirearms,
 resultsList: {
 maxResults:itemsToShow,
 
 element: (list, data) => {
 list.classList.add("pdp-autocomplete-results")
 if (!data.results.length) {
 const message = document.createElement('li');
 message.setAttribute('class', 'no_result');
 message.style.pointerEvents = "none";
 message.innerHTML = `No results found`;
 list.appendChild(message);
 } else {
 let resultValues = data.results.map(result=>result.value)
 let resultsList = ''
 let featuredResults = resultValues.filter(result=>result.featured)
 let standardResults = resultValues.filter(result=>!result.featured)
 if (featuredResults.length>0) {
 resultsList = `
 ${this.mapAutocompleteResults(featuredResults)}
 ${this.mapAutocompleteResults(standardResults,featuredResults.length)}
 `

 } else {
 resultsList = `
 ${this.mapAutocompleteResults(standardResults)}
 `
 }
 list.innerHTML = resultsList
 }
 },
 noResults: true,
 },
 resultItem: {
 highlight: true,
 element: (item,data)=>{
 item.textContent = data.match.fullName;
 }

 },
 events: {
 input: {
 selection: (event) => {
 
 let autoSelected = null;
 let selectedModelName = document.querySelector(`#autoComplete_result_${event.detail.selection.index}`).textContent.trim();
 let selection = window.firearmsDB.modelByFullName(selectedModelName);
 
 this.DOMTarget().querySelector("#autocomplete").value=selection.fullName; 
 if (selection) {
 this.selectedSize = null;
 this.setFirearm(selection);
 
 if (this.holstersCompatibilityCheck()) {
 let noneselected = document.querySelector(".no-model-set")
 noneselected?.parentNode.removeChild(noneselected)
 this.render();
 }
 }
 
 }
 }
 }
 });
 this.validate();
 }
 holstersCompatibilityCheck() { 
 if (this.selectedSize) {
 if (this.selectedSize!=this.currentHolster.size) {
 let sizeMatchingHolster = window.firearmsDB.siblingsOf(this.currentHolster)
 .find(holster=>holster.size==this.selectedSize);
 if (sizeMatchingHolster) {
 this.setCookieForMinutes("uch_size",sizeMatchingHolster.size,15) 
 location.href=`${sizeMatchingHolster.url}`
 return;
 }
 }
 return true;
 }
 if (this.selectedFirearm) {
 let lineHolsters = this.compatibleHolsters.filter(
 holster=>holster.line==this.currentHolster.line && holster.carryPosition==this.currentHolster.carryPosition
 ) 
 let sizeMatchingHolster = lineHolsters.find(holster=>holster.size==this.currentHolster.size);
 if (sizeMatchingHolster && this.currentHolster.id==sizeMatchingHolster.size) {
 return true;
 }
 if (this.currentHolster.line.toLowerCase()=="g3") {
 let matchOnClickRetention = this.currentHolster.selectionFeatures.includes("click-retention")
 let matchingG3Holster = null;
 if (matchOnClickRetention) {
 matchingG3Holster = lineHolsters.find(holster=>holster.selectionFeatures.includes("click-retention"))
 } else {
 matchingG3Holster = lineHolsters.find(holster=>!holster.selectionFeatures.includes("click-retention"))
 }
 if (matchingG3Holster==null) {
 return true;
 }
 if (matchingG3Holster.id==this.currentHolster.id) {
 return true;
 }
 location.href=`/products/${matchingG3Holster.handle}?variant=${matchingG3Holster.variants[0].id}`
 return;
 } else {
 let redirectTo = null
 if (lineHolsters.length==1) {
 if (lineHolsters[0].id!=this.currentHolster.id) {
 redirectTo = lineHolsters[0]
 } else {
 return true;

 }
 }
 if (redirectTo==null) {
 let selectBy = ["stock","optics-ready","laser-ready","extra-mag"].find(
 criterion=>this.currentHolster.selectionFeatures.includes(criterion)
 )
 if (selectBy!=null) {
 redirectTo = lineHolsters.find(holster=>holster.selectionFeatures.includes(selectBy))
 }
 }
 if (redirectTo!=null && redirectTo.id!=this.currentHolster.id) {
 
 location.href=`/products/${redirectTo.handle}?variant=${redirectTo.variants[0].id}`
 }
 return true;
 }
 
 }
 return true; 
 }
 getLineMatchingURL() {
 let lineHolsters = this.compatibleHolsters.filter(
 holster=>holster.line==this.currentHolster.line && holster.carryPosition==this.currentHolster.carryPosition
 ) 
 let sizeMatchingHolster = lineHolsters.find(holster=>holster.size==this.currentHolster.size);
 if (sizeMatchingHolster && this.currentHolster.id==sizeMatchingHolster.size) {
 return null;
 }
 if (this.currentHolster.line.toLowerCase()=="g3") {
 let matchOnClickRetention = this.currentHolster.selectionFeatures.includes("click-retention")
 let matchingG3Holster = null;
 if (matchOnClickRetention) {
 matchingG3Holster = lineHolsters.find(holster=>holster.selectionFeatures.includes("click-retention"))
 } else {
 matchingG3Holster = lineHolsters.find(holster=>!holster.selectionFeatures.includes("click-retention"))
 }
 if (matchingG3Holster==null) {
 return null;
 }
 if (matchingG3Holster.id==this.currentHolster.id) {
 return null;
 }
 return `/products/${matchingG3Holster.handle}?variant=${matchingG3Holster.variants[0].id}`
 } else {
 let redirectTo = null
 if (lineHolsters.length==1) {
 if (lineHolsters[0].id!=this.currentHolster.id) {
 redirectTo = lineHolsters[0]
 } else {
 return null;

 }
 }
 if (redirectTo==null) {
 let selectBy = ["stock","optics-ready","laser-ready","extra-mag"].find(
 criterion=>this.currentHolster.selectionFeatures.includes(criterion)
 )
 if (selectBy!=null) {
 redirectTo = lineHolsters.find(holster=>holster.selectionFeatures.includes(selectBy))
 }
 }
 if (redirectTo!=null && redirectTo.id!=this.currentHolster.id) {
 
 return `/products/${redirectTo.handle}?variant=${redirectTo.variants[0].id}`
 }
 return null;
 }
 }
}